import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=77a49dbb&scoped=true&"
import script from "./Snackbar.ts?vue&type=script&lang=js&"
export * from "./Snackbar.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a49dbb",
  null
  
)

export default component.exports